<h2 mat-dialog-title>JSON Diff Viewer</h2>

<mat-dialog-content>
    <div class="diff-container">
        <div class="diff-header">
            <div class="header-actions">
                <button mat-icon-button (click)="copyLeftJson()" matTooltip="Copy original JSON">
                    <mat-icon>content_copy</mat-icon>
                </button>
                <button mat-icon-button (click)="copyRightJson()" matTooltip="Copy modified JSON">
                    <mat-icon>content_copy</mat-icon>
                </button>
            </div>
        </div>

        <div class="tree-view">
            <div class="tree-node" *ngFor="let node of flattenedNodes"
                 [ngClass]="getNodeDiffClass(node)"
                 [style.padding-left.px]="node.level * 20">

                <mat-icon class="expand-icon" (click)="toggleNode(node)" *ngIf="hasChildren(node)">
                    {{ node.expanded ? 'expand_more' : 'chevron_right' }}
                </mat-icon>
                <span class="expand-placeholder" *ngIf="!hasChildren(node)"></span>

                <span class="node-key">{{ node.key }}</span>
                <span class="node-separator">:</span>
                <span class="node-value">{{ getDisplayValue(node) }}</span>
            </div>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-raised-button (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" (click)="onOk()">OK</button>
</mat-dialog-actions>